(function () {
  if (window.__superpromoBadgeInitialized) return;
  window.__superpromoBadgeInitialized = true;

  function parseNumber(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function pluralize(count, singular, plural) {
    return count === 1 ? singular : plural;
  }

  function normalizeCode(value) {
    return String(value || '').trim().toUpperCase();
  }

  function parseCodeList(value) {
    return String(value || '')
      .split(',')
      .map(normalizeCode)
      .filter(Boolean);
  }

  function isTrue(value) {
    return String(value || '').toLowerCase() === 'true';
  }

  function getCurrentTier(count, goals) {
    if (count >= goals.t30) return 30;
    if (count >= goals.t25) return 25;
    if (count >= goals.t20) return 20;
    return 0;
  }

  function buildMessage(count, tier, goals) {
    if (count >= goals.t30) {
      return '¡Ya desbloqueaste 30% OFF! Tu carrito alcanzó el nivel máximo de la SuperPromo.';
    }

    if (tier === 25) {
      return 'Ya tienes 25% OFF. Agrega 1 producto más y llega al 30% OFF.';
    }

    if (tier === 20) {
      var missingFor30 = Math.max(goals.t30 - count, 0);
      return 'Ya tienes 20% OFF. Agrega ' + missingFor30 + ' ' + pluralize(missingFor30, 'producto', 'productos') + ' más y llega al 30% OFF.';
    }

    if (count === 1) {
      return 'Te falta 1 producto para desbloquear 20% OFF.';
    }

    return 'Agrega 2 productos y empieza a desbloquear descuentos de hasta 30% OFF.';
  }

  function getScopeBlock(root) {
    if (!root) return document;
    return root;
  }

  function getCartText(root) {
    return normalizeCode(getScopeBlock(root).textContent);
  } 

  function hasTestDiscountCode(block, root) {
    var testCodes = parseCodeList(block.getAttribute('data-superpromo-test-codes'));
    if (!testCodes.length) return false;

    var liquidDiscounts = parseCodeList(block.getAttribute('data-superpromo-active-discounts'));
    if (liquidDiscounts.some(function (code) { return testCodes.indexOf(code) !== -1; })) {
      return true;
    }

    var cartText = getCartText(root);
    return testCodes.some(function (code) {
      return cartText.indexOf(code) !== -1;
    });
  }

  function shouldShowBadge(block, root) {
    if (isTrue(block.getAttribute('data-superpromo-shop-active'))) return true;
    return hasTestDiscountCode(block, root);
  }

  function setBadgeVisibility(block, isVisible) {
    block.hidden = !isVisible;
    block.classList.toggle('superpromo-badge--hidden', !isVisible);
  }

  function calculatePromoCount(scope, nonPromoIds) {
    var total = 0;
    var items = getScopeBlock(scope).querySelectorAll('[data-cart-item][data-pid]');

    items.forEach(function (item) {
      var productId = String(item.getAttribute('data-pid') || '').trim();
      if (!productId || nonPromoIds.has(productId)) return;

      var kitQty = parseNumber(item.getAttribute('data-item-kit-qty'), 1);
      var qtyInput = item.querySelector('input[name="updates[]"], input[type="number"]');
      var quantity = qtyInput ? parseNumber(qtyInput.value || qtyInput.getAttribute('data-current-qty'), 1) : 1;
      total += Math.max(quantity, 0) * Math.max(kitQty, 1);
    });

    return total;
  }

  function updateBadge(block) {
    var root = block.closest('[data-cart-wrapper]') || block.closest('[data-cart-content]') || document;
    var isVisible = shouldShowBadge(block, root);

    setBadgeVisibility(block, isVisible);

    if (!isVisible) return;

    var goals = {
      t20: parseNumber(block.getAttribute('data-superpromo-goal-20'), 2),
      t25: parseNumber(block.getAttribute('data-superpromo-goal-25'), 3),
      t30: parseNumber(block.getAttribute('data-superpromo-goal-30'), 4),
      max: parseNumber(block.getAttribute('data-superpromo-goal'), 4)
    };
    var nonPromoIds = new Set(String(block.getAttribute('data-superpromo-non-promo-ids') || '').split(',').map(function (value) {
      return value.trim();
    }).filter(Boolean));
    var count = calculatePromoCount(root, nonPromoIds);
    var tier = getCurrentTier(count, goals);
    var progress = Math.min((count / Math.max(goals.max, 1)) * 100, 100);

    var titleEl = block.querySelector('[data-superpromo-title]');
    var message = block.querySelector('[data-superpromo-message]');
    var progressFill = block.querySelector('[data-superpromo-progress]');
    var countEl = block.querySelector('[data-superpromo-count]');
    var tierEl = block.querySelector('[data-superpromo-tier]');

    if (titleEl) titleEl.textContent = tier >= 30 ? '¡30% OFF desbloqueado!' : 'Desbloquea hasta 30% OFF';
    if (message) message.textContent = buildMessage(count, tier, goals);
    if (progressFill) progressFill.style.width = progress + '%';
    if (countEl) countEl.textContent = count + ' ' + pluralize(count, 'producto', 'productos');
    if (tierEl) tierEl.textContent = tier + '% OFF actual';

    block.setAttribute('data-tier', String(tier));

    var marks = block.querySelectorAll('[data-superpromo-mark]');
    marks.forEach(function (mark) {
      var markTier = parseNumber(mark.getAttribute('data-superpromo-mark'), 0);
      var isActive = tier >= markTier;
      mark.classList.toggle('superpromo-badge__progress-mark--active', isActive);
      mark.style.color = isActive ? '#d6336c' : '';
      mark.style.fontWeight = isActive ? '700' : '';
    });
  }

  function updateAllBadges() {
    document.querySelectorAll('[data-superpromo-badge]').forEach(updateBadge);
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateAllBadges();

    /* Re-run when cart items appear after initial render (AJAX / lazy) */
    var cartWrapper = document.querySelector('[data-cart-wrapper]');
    if (cartWrapper) {
      var observer = new MutationObserver(function () {
        setTimeout(updateAllBadges, 100);
      });
      observer.observe(cartWrapper, { childList: true, subtree: true });
    }
  });

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-superpromo-toggle]');
    if (!toggle) return;
    var badge = toggle.closest('[data-superpromo-badge]');
    if (badge) badge.classList.toggle('superpromo-badge--open');
  });

  if (window.jQuery_T4NT) {
    jQuery_T4NT(document).on('cart:updated.superpromoBadge add:cart:success.superpromoBadge', function () {
      setTimeout(updateAllBadges, 150);
    });
  }

  if (window.FoxkitEvents && typeof window.FoxkitEvents.subscribe === 'function') {
    window.FoxkitEvents.subscribe('ON_FOXKIT_CART_UPDATE', function () {
      setTimeout(updateAllBadges, 150);
    });
  }

  window.SuperPromoBadge = window.SuperPromoBadge || { update: updateAllBadges };
})();
